import { SVGInterface } from "../../interface";

const NearMeDisabled = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M11.295 7.04498L20.295 3.70498L16.955 12.705L15.395 11.145L16.895 7.09498L12.845 8.59498L11.295 7.04498ZM20.485 21.895L15.415 16.825L13.605 21.705H12.195L9.36498 14.635L2.29498 11.805V10.395L7.17498 8.58498L2.10498 3.51498L3.51498 2.10498L21.895 20.485L20.485 21.895ZM13.865 15.275L8.72498 10.135L6.01498 11.145L10.905 13.095L12.855 17.985L13.865 15.275Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default NearMeDisabled;
